import { z } from 'zod';
import { Id, Int64, JsonObject, Slug, Timestamp, Uri, atLeastOneField } from './common.js';

export const Workspace = z.object({
  id: Id,
  slug: Slug,
  name: z.string().max(120),
  logo_url: Uri.nullable().optional(),
  storage_quota_bytes: Int64,
  storage_used_bytes: Int64,
  owner_member_id: Id,
  settings: JsonObject.optional(),
  default_library_id: Id.optional(),
  created_at: Timestamp,
});
export type Workspace = z.infer<typeof Workspace>;

export const WorkspaceCreate = z.object({
  name: z.string().min(1).max(120),
  slug: Slug.optional(),
});
export type WorkspaceCreate = z.infer<typeof WorkspaceCreate>;

export const WorkspaceUpdate = atLeastOneField(
  z.object({
    name: z.string().min(1).max(120).optional(),
    slug: Slug.optional(),
    logo_url: Uri.nullable().optional(),
    storage_quota_bytes: Int64.optional(),
    settings: JsonObject.optional(),
  }),
);
export type WorkspaceUpdate = z.infer<typeof WorkspaceUpdate>;

/** Inline body of `POST /workspaces/{id}/transfer-ownership` (not a named component). */
export const TransferOwnershipRequest = z.object({ member_id: Id });
export type TransferOwnershipRequest = z.infer<typeof TransferOwnershipRequest>;
